<template>
  <fieldset :class="{ 'd-none': !show }">
    <h2>{{ title }}</h2>

    <slot />
  </fieldset>
</template>

<script>
// @vuese
// Sekcja kreatora
// @group Wizard
export default {
  name: 'Section',
  props: {
    title: String
  },
  data() {
    return {
      show: true
    };
  }
};
</script>

